import { useTranslation } from 'react-i18next';
import { StyleSheet, View } from 'react-native';

import { useCurrencyString } from 'util/helpers/currency';
import { VerticalDivider } from 'components';

import { SubHeaderField } from '../OrderHeader/Fields';
import type { FinancialInfo } from 'store/Orders/types';

type FinancialInfoProps = {
  financialInfo: FinancialInfo;
};

export const FinancialInfoSection = ({ financialInfo }: FinancialInfoProps) => {
  const { t } = useTranslation();

  const getCurrencyString = useCurrencyString();

  return (
    <View
      style={{
        width: '100%',
        alignSelf: 'stretch',
      }}
    >
      <View
        style={[
          styles.subHeader,
          {
            borderRadius: 4,
            backgroundColor: 'black',
            alignSelf: 'stretch',
            paddingVertical: 12,
          },
        ]}
      >
        <View style={styles.column}>
          <SubHeaderField
            label={t('overview.orderDetails.itemSubtotal')}
            value={getCurrencyString(financialInfo.items_subtotal)}
          />
          <SubHeaderField
            label={t('overview.orderDetails.deposit')}
            value={getCurrencyString(financialInfo.deposit)}
          />
        </View>
        <VerticalDivider color={'white'} />
        <View style={styles.column}>
          <SubHeaderField
            label={t('overview.orderDetails.deliveryFee')}
            value={getCurrencyString(financialInfo.delivery_fee)}
          />
          <SubHeaderField
            label={t('overview.orderDetails.discount')}
            value={getCurrencyString(financialInfo.discount)}
          />
        </View>
        <VerticalDivider color={'white'} />
        <View style={styles.column}>
          <SubHeaderField
            label={t('overview.orderDetails.credit')}
            value={getCurrencyString(financialInfo.credit)}
          />
          <SubHeaderField
            label={t('overview.orderDetails.tax')}
            value={getCurrencyString(financialInfo.tax)}
          />
        </View>
        <VerticalDivider color={'white'} />
        <View style={styles.column}>
          <SubHeaderField
            label={t('overview.orderDetails.tip')}
            value={getCurrencyString(financialInfo.total_tip_left_for_driver)}
          />
          <SubHeaderField
            label={t('overview.orderDetails.total')}
            value={getCurrencyString(financialInfo.grand_total_including_tax)}
          />
        </View>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  column: {
    flex: 1,
    minWidth: 60,
    paddingHorizontal: 12,
    gap: 8,
  },
  subHeader: {
    flexGrow: 1,
    flexShrink: 1,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    flexWrap: 'wrap',
  },
});
